module.exports = __webpack_public_path__ + "img/growing-heart-emoji.e76eda7f.png";